import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../app/store';

/**
 * No API calls here - auth is initialized by AuthProvider
 * Token refresh is handled automatically by the API interceptor
 */
export default function ProtectedRoute({ children }: { children: JSX.Element }) {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const isInitialized = useAppSelector((state) => state.auth.isInitialized);

  const location = useLocation();

  // Wait for auth initialization to complete prevents redirecting before verification
  if (!isInitialized) {
    return null;  // Show loader in future if required
  }

  // If not authenticated, redirect to signin
  if (!isAuthenticated) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // User is authenticated, render the protected content
  return children;
}
